import {Document} from 'notebook/documents/DocumentConstants';
import {Note} from 'notebook/util/NoteUtilConstants';

export function getNoteFromDocument(document: Document): Note {
  return document.documentVersion.entryVersion.note;
}

export function getNotesByDocumentId(documents: {[documentId: string]: Document}): {
  [documentId: string]: Note;
} {
  const notes: {[documentId: string]: Note} = {};
  Object.values(documents).forEach((document) => {
    notes[document.id] = getNoteFromDocument(document);
  });
  return notes;
}
